import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * This Directive was created to validate the Margin values.
 * This should allow only numbers in a range of -99 to 99 including 0.
 */
@Directive({
  selector: '[psUiMarginRange]',
})
export class MarginRangeDirective {
  constructor(private _element: ElementRef, public model: NgControl) {}

  @HostListener('focusout', ['$event'])
  onEvent() {
    let value: string = this._element.nativeElement.value;

    if (value === '' || !value || this._haveLetters(value)) {
      value = '0';
    }

    // allow empty values and a leading -
    if (value === '' || value === '-') {
      return;
    }

    this.model.control?.setValue(Number(Number(value).toFixed(2)));
  }

  private _haveLetters(value: string) {
    return new RegExp(/^[a-zA-Z]+$/).test(value);
  }
}
